<template>
  <div :class="classesTabComplexBase">
    <button
      type="button"
      :draggable="draggable"
      :disabled="disabled"
      @click.stop.prevent
      @dragstart.stop="onDragStart"
      @dragend.stop="onDragEnd"
    >
      <IconBase :icon="dragIcon" :tone="disabled ? 'disabled' : 'tertiary'" />
    </button>

    <button type="button" :class="style.textButton" :disabled="disabled">
      <slot>
        {{ text }}
      </slot>
    </button>

    <ButtonIcon
      :size="getButtonIconSize"
      :icon="icon"
      variant="ghost"
      :disabled="disabled"
      @click.stop="actionHandler"
    />
  </div>
</template>

<script lang="ts">
import {defineComponent, PropType} from "vue";
import style from "./TabComplex.module.scss";

import moreIcon from "$images/icons/tabs/Name=More, Size=16.svg";
import dragIcon from "$images/icons/tabs/Name=Drag-vertical, Size=16.svg";

import IconBase from "@/elements/UI/icon/IconBase.vue";
import ButtonIcon from "@/elements/UI/button/ButtonIcon/ButtonIcon.vue";

export default defineComponent({
  name: "TabComplexBase",

  components: {
    ButtonIcon,
    IconBase
  },

  emits: ["drag-start", "drag-end"],

  props: {
    text: {
      type: String,
      default: ""
    },
    size: {
      type: String as PropType<Size>,
      default: "M"
    },
    icon: {
      type: String,
      default: moreIcon
    },
    active: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    },
    draggable: {
      type: Boolean,
      default: false
    },
    actionHandler: {
      type: Function,
      default: () => ({})
    }
  },

  data() {
    return {
      style,
      moreIcon,
      dragIcon
    };
  },

  methods: {
    onDragStart(event: DragEvent): void {
      this.$emit("drag-start", event);
    },

    onDragEnd(event: DragEvent): void {
      this.$emit("drag-end", event);
    }
  },

  computed: {
    getButtonIconSize() {
      return this.size === "S" ? 24 : 28;
    },
    classesTabComplexBase() {
      return [this.style.tabBase, this.style[`size${this.size}`]];
    }
  }
});
</script>
